import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
function Transition({
  show = true,
  enter = null,
  enterFrom = null,
  enterTo = null,
  leave = null,
  leaveFrom = null,
  leaveTo = null,
  children = null,
  onClick = () => {},
  className = '',
  mountOnEnter = false,
  unmountOnExit = true,
  appear = true,
  style = {},
  shouldEnter = true,
  shouldExit = true,
  'data-cy': dataCy,
  onExit = () => {},
  onEnter = () => {},
  ...rest
}) {
  const nodeRef = useRef(null)
  const enterClasses = enter && enter.split(' ')
  const enterFromClasses = enterFrom && enterFrom.split(' ')
  const enterToClasses = enterTo && enterTo.split(' ')
  const leaveClasses = leave && leave.split(' ')
  const leaveFromClasses = leaveFrom && leaveFrom.split(' ')
  const leaveToClasses = leaveTo && leaveTo.split(' ')
  return (
    <CSSTransition
      {...rest}
      nodeRef={nodeRef}
      enter={shouldEnter}
      exit={shouldExit}
      onClick={onClick}
      appear={appear}
      mountOnEnter={mountOnEnter}
      unmountOnExit={unmountOnExit}
      in={show}
      data-cy={dataCy}
      className={className}
      style={style}
      addEndListener={(done) => {
        nodeRef.current?.addEventListener('transitionend', done, false)
      }}
      onEnter={() => {
        const node = nodeRef.current
        if (!node) return
        onEnter(node)
        if (leaveToClasses) node.classList.remove(...leaveToClasses)
        if (enterClasses) node.classList.add(...enterClasses)
        if (enterFromClasses) node.classList.add(...enterFromClasses)
      }}
      onEntering={() => {
        const node = nodeRef.current
        if (!node) return
        if (enterFromClasses) node.classList.remove(...enterFromClasses)
        if (enterToClasses) node.classList.add(...enterToClasses)
      }}
      onEntered={() => {
        const node = nodeRef.current
        if (!node) return
        if (enterClasses) node.classList.remove(...enterClasses)
      }}
      onExit={() => {
        const node = nodeRef.current
        if (!node) return
        onExit(node)
        if (enterToClasses) node.classList.remove(...enterToClasses)
        if (leaveClasses) node.classList.add(...leaveClasses)
        if (leaveFromClasses) node.classList.add(...leaveFromClasses)
      }}
      onExiting={() => {
        const node = nodeRef.current
        if (!node) return
        if (leaveFromClasses) node.classList.remove(...leaveFromClasses)
        if (leaveToClasses) node.classList.add(...leaveToClasses)
      }}
      onExited={() => {
        const node = nodeRef.current
        if (!node) return
        if (leaveClasses) node.classList.remove(...leaveClasses)
      }}
    >
      <div ref={nodeRef}>{children}</div>
    </CSSTransition>
  )
}

Transition.propTypes = {
  show: PropTypes.bool,
  enter: PropTypes.string,
  enterFrom: PropTypes.string,
  enterTo: PropTypes.string,
  leave: PropTypes.string,
  leaveFrom: PropTypes.string,
  leaveTo: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  'data-cy': PropTypes.string,
  unmountOnExit: PropTypes.bool,
  mountOnEnter: PropTypes.bool,
  appear: PropTypes.bool,
  style: PropTypes.object,
  shouldEnter: PropTypes.bool,
  shouldExit: PropTypes.bool,
  onEnter: PropTypes.func,
  onExit: PropTypes.func
}

export default Transition
